import { apiFetch } from "../auth/apiClient";

export const amenitiesApi = {
  list: ({ signal } = {}) =>
    apiFetch("/api/amenities", { method: "GET", authRequired: true, signal }),

  slots: (amenityId, date, { signal } = {}) =>
    apiFetch(`/api/amenities/${amenityId}/slots?date=${date}`, {
      method: "GET",
      authRequired: true,
      signal,
    }),

  book: (body, { signal } = {}) =>
    apiFetch("/api/amenity-bookings", {
      method: "POST",
      authRequired: true,
      body,
      signal,
    }),

  myBookings: ({ signal } = {}) =>
    apiFetch("/api/amenity-bookings", {
      method: "GET",
      authRequired: true,
      signal,
    }),

  verifyBooking: (body, { signal } = {}) =>
    apiFetch("/api/amenity-bookings/verify", {
      method: "POST",
      authRequired: true,
      body,
      signal,
    }),

  cancel: (bookingId, { signal } = {}) =>
    apiFetch(`/api/amenity-bookings/${bookingId}/cancel`, {
      method: "POST",
      authRequired: true,
      signal,
    }),

  patch: (amenityId, body, { signal } = {}) =>
    apiFetch(`/api/amenities/${amenityId}`, {
      method: "PATCH",
      authRequired: true,
      body,
      signal,
    }),
};
